
import { Component, Vue, Emit, Prop } from "vue-property-decorator";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import Spinner from "@/components/Spinner.vue";

@Component({
  components: {
    Loading,
    Spinner,
  },
})
export default class Loader extends Vue {
  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: true })
  is_full_page!: boolean;
}
